export enum EmployeeStatus {
  Active = 'active',
  Blocked = 'blocked',
}
